<div class="ct-blogs-container" *ngIf="blogData.length > 0">
  <h2>Read articles about {{category | slugText : 'capitalize'}}</h2>
  <p class="desc">Head over to Avaana answers for everything you need to know about {{category | slugText : 'capitalize'}}</p>
  <div class="ct-blogs">
    <div class="health-list">
      <ng-container *ngFor="let item of blogData | slice : 0 : 4">
        <div class="health-card">
          <img class="img-holder" *ngIf="item.images" src="" alt="">
          <div class="img-holder" *ngIf="!item.images">
            {{item.title.rendered | slice : 0 : 2}}
          </div>
          <div class="health-card-details">
            <p class="category">{{fetchCategory(item.categories[0])}}</p>
            <p class="title" [innerHTML]="item.title.rendered"></p>
            <!-- <p class="author">Jane Appleseed</p> -->
            <a [href]="item.link" target="_blank">Read more <img src="assets/images/arrow-back.svg" alt=""></a>
          </div>
        </div>
      </ng-container>
    </div>
    <button class="visit-blog" [routerLink]="'/blog'">Visit Health Hub</button>
  </div>
</div>
